import { motion } from "framer-motion";
import { Reveal, Kicker } from "./Reveal";
import { GALLERY } from "../../data/site";

// Bento spans for premium asymmetry
const SPANS = [
    "md:col-span-2 md:row-span-2",
    "md:col-span-1 md:row-span-1",
    "md:col-span-1 md:row-span-1",
    "md:col-span-1 md:row-span-2",
    "md:col-span-2 md:row-span-1",
    "md:col-span-1 md:row-span-1",
    "md:col-span-1 md:row-span-1",
    "md:col-span-2 md:row-span-1",
];

export const Gallery = () => {
    return (
        <section
            id="galerie"
            data-testid="gallery-section"
            className="relative bg-black py-24 text-white md:py-36"
        >
            <div className="mx-auto max-w-7xl px-6 md:px-12">
                <div className="flex flex-col justify-between gap-6 md:flex-row md:items-end">
                    <div>
                        <Reveal>
                            <Kicker>Galerie</Kicker>
                        </Reveal>
                        <Reveal delay={0.05}>
                            <h2 className="mt-6 font-display text-4xl font-semibold leading-[1.05] tracking-tight sm:text-5xl lg:text-6xl">
                                Munca noastră <span className="text-gold">vorbește</span>
                            </h2>
                        </Reveal>
                    </div>
                    <Reveal delay={0.1}>
                        <p className="max-w-sm font-body text-neutral-400">
                            Tunsori moderne, skin fade, barbă conturată și atmosfera unui
                            salon premium.
                        </p>
                    </Reveal>
                </div>

                <div className="mt-14 grid auto-rows-[220px] grid-cols-1 gap-4 sm:grid-cols-2 md:grid-cols-4">
                    {GALLERY.map((img, i) => (
                        <motion.div
                            key={i}
                            data-testid={`gallery-item-${i}`}
                            initial={{ opacity: 0, y: 30 }}
                            whileInView={{ opacity: 1, y: 0 }}
                            viewport={{ once: true, margin: "-60px" }}
                            transition={{ duration: 0.7, delay: (i % 4) * 0.06, ease: [0.22, 1, 0.36, 1] }}
                            className={`group relative overflow-hidden rounded-xl border border-white/10 ${SPANS[i]}`}
                        >
                            <img
                                src={img.src}
                                alt={img.alt}
                                loading="lazy"
                                className="img-cover transition-all duration-700 ease-out group-hover:scale-105 md:grayscale md:group-hover:grayscale-0"
                            />
                            <div className="absolute inset-0 bg-gradient-to-t from-black/70 via-transparent to-transparent opacity-0 transition-opacity duration-500 group-hover:opacity-100" />
                            <span className="absolute bottom-4 left-4 translate-y-3 font-body text-xs uppercase tracking-widest text-white opacity-0 transition-all duration-500 group-hover:translate-y-0 group-hover:opacity-100">
                                {img.alt}
                            </span>
                        </motion.div>
                    ))}
                </div>
            </div>
        </section>
    );
};
